import { Link, Navigate, useParams } from 'react-router-dom';
import styles from './index.module.scss';
import SiteTopNav from '@/components/SiteTopNav';
import {
  useProductStore,
  toRouteKey,
  firstGalleryImageUrl,
  cssBackgroundImageUrl,
} from '@/store/product';

const Collections = () => {
  const { collectionKey } = useParams();
  const collection = useProductStore(s =>
    s.collections.find(
      c => c.routeKey === collectionKey || toRouteKey(c.collection_name) === collectionKey
    )
  );

  if (!collection) {
    return <Navigate to="/products" replace />;
  }

  const products = collection.products ?? [];
  const title = collection.collection_name ?? collection.title ?? 'Collection';
  const pathSegment = collection.routeKey ?? collectionKey;

  return (
    <div className={styles['collections-page']}>
      <div>
        <header className={styles['collections-hero']}>
          <div className={styles['collections-hero__overlay']}>
            <SiteTopNav />
            <h1 className={styles['collections-hero__title']} data-motion="hero">
              {title}
            </h1>
          </div>
        </header>

        <main className={styles['collections-main']}>
          <section
            className={styles['collections-grid-section']}
            aria-labelledby="collections-title"
          >
            <h2
              id="collections-title"
              className={styles['collections-grid-section__title']}
              data-motion="title"
            >
              {products.length} COLOR{products.length === 1 ? '' : 'S'} AVAILABLE
            </h2>
            <div className={styles['collections-grid']}>
              {products.map(product => {
                const cardUrl = firstGalleryImageUrl(product);
                const bg = cssBackgroundImageUrl(cardUrl);
                return (
                  <article
                    key={product.routeKey}
                    className={styles['color-card']}
                    style={bg ? { backgroundImage: bg } : undefined}
                    data-motion="card"
                  >
                    <h3 className={styles['color-card__name']}>{product.product_name}</h3>
                    <Link
                      className={styles['color-card__action']}
                      to={`/products/${pathSegment}/${product.routeKey}`}
                      data-motion-interactive="press"
                    >
                      View More
                    </Link>
                  </article>
                );
              })}
            </div>
          </section>
        </main>
      </div>
    </div>
  );
};

export default Collections;
